import { useState, useCallback, useMemo } from 'react'
import { useSubscription } from 'streamr-client-react'
import useIsMounted from '~hooks/useIsMounted'

const DATA_METADATA_STREAM_ID = '0x7c56a3197f4277dcf08881a7988f3150d1f87510/DATA-metadata'

export default function useRealtimeDataTokenStream() {
    const isMounted = useIsMounted()

    const [DATAUSDPoint, setDataPoint] = useState(0)
    const [DATAUSDVolumePoint, setVolumePoint] = useState(0)
    const [DATAUSDMarketCapPoint, setMarketCap] = useState(0)
    const [circulatingSupplyValue, setCirculatingSupply] = useState(0)
    const [totalSupplyValue, setTotalSupply] = useState(0)

    const onStatsMessage = useCallback(({
        DATAUSD,
        DATAUSDMarketCap,
        DATAUSDVolume,
        circulatingSupply,
        totalSupply,
    }) => {
        if (isMounted()) {
            setDataPoint(DATAUSD)
            setVolumePoint(DATAUSDVolume)
            setMarketCap(DATAUSDMarketCap)
            setCirculatingSupply(circulatingSupply)
            setTotalSupply(totalSupply)
        }
    }, [isMounted])

    useSubscription({
        stream: DATA_METADATA_STREAM_ID,
        resend: {
            last: 1,
        },
    }, {
        onMessage: onStatsMessage,
    })

    return useMemo(() => ({
        DATAUSDPoint,
        DATAUSDVolumePoint,
        DATAUSDMarketCapPoint,
        circulatingSupply: circulatingSupplyValue,
        totalSupply: totalSupplyValue,
    }), [
        DATAUSDPoint,
        DATAUSDVolumePoint,
        DATAUSDMarketCapPoint,
        circulatingSupplyValue,
        totalSupplyValue,
    ])
}
